var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimes = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2684FF",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M5.625 12.375 9 9m0 0 3.375-3.375M9 9l3.375 3.375M9 9 5.625 5.625"
})));
export default SvgTimes;